












import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { IBanner } from '~/assets/interfaces/banners'
import MixinGeneral from '~/assets/mixins/general'

@Component({
  components: {
    ComponentBannerStandard: () =>
      import('~/components/banners/banner-standard.vue'),
  },
})
export default class ComponentPageIndexBannersContent extends mixins(
  MixinGeneral
) {
  @Prop({ type: Array, default: () => [] }) readonly banners!: IBanner[]
  @Prop({ type: Boolean, default: false }) readonly vertical!: boolean
  @Prop({ type: Boolean, default: false }) readonly needPreload!: boolean

  get preloadIndexes(): Set<number> {
    if (!this.needPreload) return new Set()

    const len = this.banners.length
    if (len === 1) return new Set([0])
    if (len % 2 === 1) return new Set([len - 1])

    return new Set()
  }

  get bannersClass(): Record<string, boolean> {
    return {
      [this.$style.banners]: true,
      [this.$style.vertical]: this.vertical,
    }
  }
}
